// Lib
import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import "./ReassignmentTourModal.scss";

// Components
import Modal from "components/common/Modal/Modal";
import ButtonComponent from "components/common/Button/ButtonComponent";

// Interfaces
import { IReassignTourPayload, ITourReassignmentModalProps } from "interfaces/Index";


const ReassignmentTourModal: React.FunctionComponent<ITourReassignmentModalProps> = (
  props
) => {
  const [confirmationModal, setConfirmationModal] = useState(props.open);

  const closeConfirmationModal = () => { 
		setConfirmationModal(false);
		if(props.closeHandler) {
			props.closeHandler(false);
		}
	}

  const reassignTourHandler = () => {
	const { reassignTour } = props;
    const payload: IReassignTourPayload = {
			riderId: props.riderId,
			tourNumber: props.tourNumber
    };
    reassignTour(payload);
		closeConfirmationModal();

  };

  return (
	<Modal
    showModal={confirmationModal}
		closeModalHandler={closeConfirmationModal}
    modalHeading="Reassign"
    showProgressString={false}
    containerClass='tour-order-confirmation-modal'
    childrenWrapper="tour-order-confirmation-body"
  >
    {props.texts.map((text: string) => {
			return <p>{text}</p>
		})}
    <Container className="action-container" >
			<Row>
				<Col lg="6" className='left-column columns'>
					<ButtonComponent
						buttonClass="confirmation-button btn-primary"
						buttonText={'Yes'}
						onClickHandler={reassignTourHandler}
					/>
				</Col>
				<Col lg="6" className='right-column columns'>
					<ButtonComponent
						buttonClass="confirmation-button btn-primary-outline"
						buttonText={'Cancel'}
						onClickHandler={closeConfirmationModal}
					/>
				</Col>
			</Row>
    </Container>
  </Modal>)
};

export default ReassignmentTourModal;
